import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import Statement from '../components/Statement';
import Services from '../components/Services';
import Portfolio from '../components/Portfolio';
import Process from '../components/Process';
import CTA from '../components/CTA';
import Footer from '../components/Footer';
import ScrollPortfolio from '../components/ScrollPortfolio';
import AboutSection from 'components/About';

const MainPage = () => {
  return (
    <div className='flex flex-col'>
      <Navbar />

      <Hero />

      {/* <Statement /> */}

      <ScrollPortfolio />
      <Services />
      {/* <AboutSection /> */}
      <Process />

      <CTA />

      <Footer />
    </div>
  );
};

export default MainPage;
